<template>
    <MenuForm :url="url" :menu="menu" :errors="errors" :routes="routes" v-on:onUpdateMenu="onUpdateMenu" v-on:save="saveMenu"></MenuForm>
</template>

<script>
import MenuForm from './MenuForm'
export default {
  name: 'MenuEdit',
  components: {MenuForm},
  props: ['url'],
  data () {
    return {
      menu: {},
      errors: {},
      routes: []
    }
  },
  methods: {
    onUpdateMenu (val) {
      this.menu = val
    },
    saveMenu () {
      let self = this

      this.$http
        .put(this.url + `/update/${this.$route.params.id}`, this.menu, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data && res.data.data !== 'undefined') {
            self.menu = res.data.data

            localStorage.removeItem('menu')
            this.loadMenu()
          } else {
            this.errors = res.response.data.errors
          }
        }).catch(res => {

        })
    },
    loadMenu () {
      let ep = JSON.parse(localStorage.getItem('endpoints'))

      if (ep.services['menu']) {
        this.apiUrl = ep.services['menu'] + '/' + process.env.API_ENDPOINT + '/admin/menu'
      } else {
        this.apiUrl = process.env.API_URL + '/' + process.env.API_ENDPOINT + '/admin/menu'
      }

      this.$http
        .get(this.apiUrl + `/admin-menu`, {
          'headers': {
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          this.$store.commit('loading/setMenu', res.data.data)
          this.$router.push('/admin/menu/index')
        }).catch(res => {

        })
    }
  },
  created: function () {
    this.$emit('updateTitle', 'Menu ' + this.$translate.t('Edit'))

    let self = this

    this.$http
      .get(this.url + `/routes`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.routes = res.data

        localStorage.removeItem('menu')
      }).catch(res => {

      })

    this.$http
      .get(this.url + `/show/${this.$route.params.id}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        self.menu = res.data.data
      }).catch(res => {

      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/menu/MenuEdit.vue